import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
@Component({
    selector: 'app-assign-confirm-dialog',
    templateUrl: './assign-confirm-dialog.component.html',
    styleUrls: ['./assign-confirm-dialog.component.scss']
})
export class AssignConfirmDialogComponent {
    moment = moment;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<AssignConfirmDialogComponent>) {
    }
}
